module.exports = (url) ->
  url.indexOf(window.attachmentsDomain) == 0



// WEBPACK FOOTER //
// ./app/scripts/lib/util/url/is-trello-attachment.coffee